// (C) Copyright 2020 MediaWink, LLC

const EMPTY_IMAGE = 'https://images.unsplash.com/photo-1588345921523-c2dcdb7f1dcd?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80';
export { EMPTY_IMAGE };
